export const actionTypes = {
    Open: "[Open] Action",
    Success: "[Success] Action",
    Variant: "[Variant] Action",
    Message: "[Message] Action"
};

const initialState = {
    open: false,
    variant: 'error',
    message: 'خطا! لطفا دوباره تلاش کنید.'
};

export function reducer(state = initialState, action) {
    // The reducer normally looks at the action type field to decide what happens
    switch (action.type) {
        case actionTypes.Open :
            return {
                ...state,
                open: action.payload,
            };
        case actionTypes.Success :
            return {
                ...state,
                open: true,
                message: 'عملیات با موفقیت انجام شد!',
                variant: 'success'
            };
        case actionTypes.Variant :
            return {
                ...state,
                variant: action.payload,
            };
        case actionTypes.Message :
            return {
                ...state,
                open: true,
                message: action.payload,
                variant: 'error'
            };
        default:
            return state
    }
}

export const actions = {
    openNotification: (payload) => ({type: actionTypes.Open, payload}),
    openSuccessNotification: () => ({type: actionTypes.Success})
};